<template>
    <div class="notice common-card">
        <div class="card-title">
            <p>通知消息</p>
            <div style="margin-left: auto;">
                <el-button type="text" @click="routerHandle">更多></el-button>
            </div>
        </div>
        <div class="common-content" v-loading="loading">
            <div class="hidden-content scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut">
                <template v-if="total > 0">
                    <div
                        v-for="item in dataList"
                        :key="item.id"
                        class="notice-item"
                    >
                        <el-tooltip
                            effect="light"
                            :content="`${formattTime(item.sendTime)} ${item.content}`"
                            popper-class="notice-popper"
                        >
                            <span class="item-content" 
                                :class="setClass(item)"
                            >
                                {{formattTime(item.sendTime)}} {{item.content}}
                            </span>
                        </el-tooltip>
                        <el-button type="text" class="item-btn" title="忽略" @click="ignoreHandle(item)">忽略</el-button>
                    </div>
                </template>
                <div v-else class="no-message">
                    <img :src="`${require('@/assets/images/nomessage.png')}`" alt="">
                    <p>暂无消息</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {apiBasicMsglogList,apiIgnoreMsg} from '@/server/new.js';
export default {
    data() {
        return {
            loading: false,
            dataList: [],
            total: 0
        }
    },
    computed: {
        userinfo: {
            get () {
                return this.$store.state.user.userinfo
            }
        }
    },
    mounted() {
        this.apiBasicMsglogList();
    },
    methods: {
        formattTime(time) {
            try {
                let st = time.split(' ')[0].slice(5,10);
                let en = time.split(' ')[1].slice(0,5);
                return `${st} ${en}`;
            } catch (error) {
                console.log(error)
            }
        },
        setClass(row) {
            if(row.status !== '2') {
                return 'unread';
            }
        },
        apiBasicMsglogList() { //获取数据
            this.loading = true;
            apiBasicMsglogList({
                filter: {
                    receiveUserId: this.userinfo.userId,
                    ignoreFlag: false,
                    sendType: 1,
                    actionType: 1
                }
            }).then(({data}) => {
                this.dataList = data.rows || [];
                this.total = data.total || 0;
            }).finally(() => { this.loading = false; })
        },
        ignoreHandle(row) { //忽略按钮
            apiIgnoreMsg({id: row.id}).then(({data}) => {
                if(data.code === '1') {
                    this.$message.success('忽略成功')
                    this.apiBasicMsglogList();
                }else {
                    this.$message.errir(data.msg)
                }
            })
        },
        routerHandle() { //更多按钮
            this.$router.push({
                name: 'messagelist'
            })
        }
    }
}
</script>

<style lang="less" scoped>
.notice {
    .hidden-content {
        padding: 8px 16px 8px;
    }
    .notice-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-bottom: 1px dashed #EEEEEE;
        .item-content {
            width: calc(100% - 100px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-left: 10px;
            position: relative;
            color: rgba(0,0,0,.85);
            font-weight: 400;
            &:hover {
                color: #2568EC;
            }
            &:before {
                content: '';
                width: 3px;
                height: 3px;
                background: #2568EC;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            &.unread {
                color: @--color-primary;
            }
        }
    }
}
</style>